export const ACTIVE_STATUS = {
    Active: true,
    Inactive: false
};

export const ACTIVE_STATUS_LIST = [
    { value: "true", text: "Active" },
    { value: "false", text: "Inactive" }
];

export function getActiveStatusList() {
    return ACTIVE_STATUS_LIST;
}

export function getActiveStatusName(isActive: boolean): string {
    return isActive ? "Active" : "Inactive";
}
